import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PromiseStatuses } from "../../../../utils"
import { filtersDTO, NotThirdPartyProcessingCreateDTO, NotThirdPartyProcessingResponseDTO, NotThirdPartyResponseDTO, NotThirdPartyStructureResponseDTO } from "./dataService/dto"
import { NewNotThirdPartyService } from "./dataService/service"

interface NotificationProductiveUnitState {
    onEdit: boolean
    getAllUpRowsStatus: PromiseStatuses
    getAllNotThirdPartyResponse?: NotThirdPartyResponseDTO
    getAllNotThirdPartyProcessingResponse?: NotThirdPartyProcessingResponseDTO
    getAllNotThirdPartyStructureResponse?: NotThirdPartyStructureResponseDTO
    createProcessing: NotThirdPartyProcessingCreateDTO
    creationProcessingStatus: PromiseStatuses
    getAllNotThirdPartyStatus: PromiseStatuses
    getAllNotThirdPartyStructureStatus: PromiseStatuses
    getAllNotThirdPartyProcessingStatus: PromiseStatuses
    filtersUp: filtersDTO
}

const initialState: NotificationProductiveUnitState = {
    onEdit: false,
    getAllUpRowsStatus: 'idle',
    getAllNotThirdPartyStatus: 'idle',
    getAllNotThirdPartyProcessingStatus: 'idle',
    getAllNotThirdPartyStructureStatus: 'idle',
    creationProcessingStatus: 'idle',
    createProcessing: {},
    filtersUp: {
        page: 0,
        itemsPerPage: 0
    }
}

export const thirdPatyProcessingCreate = createAsyncThunk(
    'Not/thirdPatyProcessingCreate',
    async (body: NotThirdPartyProcessingCreateDTO, thunkApi): Promise<void> => {
        const NotThirdPartyService = NewNotThirdPartyService()
        return NotThirdPartyService.CreateProcessing(body).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetAllNotThirdParty = createAsyncThunk(
    'Not/GetAllNotThirdParty',
    async (filters: filtersDTO, thunkApi): Promise<NotThirdPartyResponseDTO> => {
        const NotThirdPartyService = NewNotThirdPartyService()
        return NotThirdPartyService.GetAllNotThirdParty(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetAllNotThirdPartyProcessing = createAsyncThunk(
    'Not/GetAllNotThirdPartyProcessing',
    async (filters: filtersDTO, thunkApi): Promise<NotThirdPartyProcessingResponseDTO> => {
        const NotThirdPartyService = NewNotThirdPartyService()
        return NotThirdPartyService.GetAllNotThirdPartyProcessing(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetAllNotThirdPartyStructure = createAsyncThunk(
    'Not/GetAllNotThirdPartyStructure',
    async (filters: filtersDTO, thunkApi): Promise<NotThirdPartyStructureResponseDTO> => {
        const NotThirdPartyService = NewNotThirdPartyService()
        return NotThirdPartyService.GetAllNotThirdPartyStructure(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const NotificationLivestockSlice = createSlice({
    name: 'notificationLivestock/slice',
    initialState,
    reducers: {
        setOnEdit: (state, action) => {
            state.onEdit = action.payload
        },
        setProcessingUnitType: (state, action) => {
            state.createProcessing.productiveUnit = action.payload
        },
        setProcessingActivity: (state, action) => {
            state.createProcessing.activity = action.payload
        },
        setProcessingClassificazione: (state, action) => {
            state.createProcessing.classification = action.payload
        },
        setProcessingFiliera: (state, action) => {
            state.createProcessing.production = action.payload
        },
        setProcessingCuaa: (state, action) => {
            state.createProcessing.cuaa = action.payload
        },
        setProcessingPrintAble: (state, action) => {
            state.createProcessing.noPrinting = action.payload
        },
        setProcessingnotificationId: (state, action) => {
            state.createProcessing.notificationId = action.payload
        },
        //edit Up

        //reset 
        resetGetAllNotThirdPartyStatus: (state) => {
            state.getAllNotThirdPartyStatus = 'idle'
        },
        resetGetAllNotThirdPartyProcessingStatus: (state) => {
            state.getAllNotThirdPartyProcessingStatus = 'idle'
        },
        resetGetAllNotThirdPartyStructureStatus: (state) => {
            state.getAllNotThirdPartyStructureStatus = 'idle'
        },
        resetUpdateStatus: (state) => {
            state.getAllUpRowsStatus = 'idle'
        },
        resetCreateStatus: (state) => {
            state.creationProcessingStatus = 'idle'
        },
        resetCreateRequest: (state) => {
            state.createProcessing = {}
        },
        resetFilters: (state) => {
            state.filtersUp = {
                page: 0,
                itemsPerPage: 0
            }
        }

    },
    extraReducers(builder) {
        builder
            .addCase(GetAllNotThirdParty.pending, (state) => {
                state.getAllNotThirdPartyStatus = 'loading'
            })
            .addCase(GetAllNotThirdParty.fulfilled, (state, action) => {
                state.getAllNotThirdPartyStatus = 'successfully'
                state.getAllNotThirdPartyResponse = action.payload
            })
            .addCase(GetAllNotThirdParty.rejected, (state, action) => {
                state.getAllNotThirdPartyStatus = 'failed'
            })

            .addCase(GetAllNotThirdPartyProcessing.pending, (state) => {
                state.getAllNotThirdPartyProcessingStatus = 'loading'
            })
            .addCase(GetAllNotThirdPartyProcessing.fulfilled, (state, action) => {
                state.getAllNotThirdPartyProcessingStatus = 'successfully'
                state.getAllNotThirdPartyProcessingResponse = action.payload
            })
            .addCase(GetAllNotThirdPartyProcessing.rejected, (state, action) => {
                state.getAllNotThirdPartyProcessingStatus = 'failed'
            })

            .addCase(GetAllNotThirdPartyStructure.pending, (state) => {
                state.getAllNotThirdPartyStructureStatus = 'loading'
            })
            .addCase(GetAllNotThirdPartyStructure.fulfilled, (state, action) => {
                state.getAllNotThirdPartyStructureStatus = 'successfully'
                state.getAllNotThirdPartyStructureResponse = action.payload
            })
            .addCase(GetAllNotThirdPartyStructure.rejected, (state, action) => {
                state.getAllNotThirdPartyStructureStatus = 'failed'
            })

            .addCase(thirdPatyProcessingCreate.pending, (state) => {
                state.creationProcessingStatus = 'loading'
            })
            .addCase(thirdPatyProcessingCreate.fulfilled, (state, action) => {
                state.creationProcessingStatus = 'successfully'
            })
            .addCase(thirdPatyProcessingCreate.rejected, (state, action) => {
                state.creationProcessingStatus = 'failed'
            })
    }
})

export const {
    setOnEdit,
    resetUpdateStatus,
    resetGetAllNotThirdPartyStatus,
    resetGetAllNotThirdPartyStructureStatus,
    resetGetAllNotThirdPartyProcessingStatus,
    setProcessingUnitType,
    setProcessingActivity,
    setProcessingClassificazione,
    setProcessingCuaa,
    setProcessingPrintAble,
    resetCreateStatus,
    setProcessingnotificationId,
    resetCreateRequest,
    setProcessingFiliera
} = NotificationLivestockSlice.actions

export default NotificationLivestockSlice.reducer